import { bootstrapApplication } from '@angular/platform-browser';
import { enableProdMode } from '@angular/core';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
ModuleRegistry.registerModules([AllCommunityModule]);

if (window.__env?.PRODUCTION === true ) {
  enableProdMode();
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
